import styled from 'styled-components'
import {
  FONT_SIZE,
  COLOR,
  Z_INDEXS,
} from '../../themes'
const Style = styled.div`
  z-index: ${Z_INDEXS.LV_0};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .SmallCalendar {
    background-color: white;
    width: 248px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    border: 1px solid ${COLOR.GRAY_13};
    padding: 16px;
    box-sizing: border-box;
    box-shadow: 0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A;
  }
  .SmallCalendar hr{
    position: relative;
    top: auto;
    left: auto;
    margin: 3px 0;
    padding: 0;
    width: none;
    align-self: stretch;
    border: 2px solid ${COLOR.GOLD_1};
    border-radius: 6px;
    background-color: ${COLOR.GOLD_1};
  }
  .SmallCalendar hr.lightLine{
    border: 1px solid ${COLOR.GOLD_1};
  }
  .calendarButton {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
  }
  .MonthnYear {
    margin: 0 0 8px 0;
    flex: 0;
    width: 100%;
    height: 40px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }
  .MonthnYear .small-year-name {
    color: ${COLOR.BLACK_6} !important;
    font-size: 18px !important;
    font-weight: 500 !important;
    font-family: 'Nunito Sans', sans-serif !important;
  }
  .calendarButton button {
    font-size: ${FONT_SIZE.MMN};
    cursor: pointer;
  }
  .calendarButton h3,
  .MonthnYear h1 {
    text-transform: capitalize;
    padding: 0;
    margin: 0;
  }
  .MonthnYear h1 {
    font-size: ${FONT_SIZE.XXS};
  }
  .calendarButton > button,
  .MonthnYear button {
    flex: 1;
    padding: 0;
    margin: 0;
    border: 0px solid transparent;
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
    background-color: white;
    border-radius: 3px;
    // color: ${COLOR.GOLD_1};
    outline: 0px;
  }
  .calendarButton > button {
    flex: 0;
    min-width: 64px;
    max-width: 64px;
    height: 30px;
    line-height: 1em;
    margin-left: 3px;
    color: white;
  }
  .MonthnYear button:hover {
    // background-color: ${COLOR.GOLD_1};
    // color: white;
  }
  .MonthnYear:active button:hover {
    background-color: transparent;
    color: ${COLOR.GOLD_1};
  }
  .MonthnYear:active button:active,
  .MonthnYear button:active {
    // color: white;
    // background-color: ${COLOR.Sky_1};
  }
  .calendarButton > button.saveButton {
    background-color: ${COLOR.GOLD_1};
    border-radius: 4px;
  }
  .calendarButton > button.closeButton {
    background-color: black;
    border-radius: 4px;
  }
  .calendarButton > button.saveButton:hover {
    border: 2px solid ${COLOR.GOLD_1};
    border-radius: 3px;
  }
  .calendarButton > button.closeButton:hover {
    border: 2px solid black;
    border-radius: 3px;
  }
  .calendarButton > button.saveButton:active {
    border: 2px solid ${COLOR.GOLD_1};
    background-color: ${COLOR.GOLD_1};
  }
  .calendarButton > button.closeButton:active {
    border: 2px solid ${COLOR.GRAY_3};
    background-color: ${COLOR.GRAY_3};
  }
  .calendarButton > button.saveButton:disabled {
    background-color: ${COLOR.GOLD_1};
  }
  .calendarField {
    flex: 1;
    position: relative;
    width: 100%;
    min-height: 216px;
  }
  .calendarField > section {
    position: absolute;
    opacity: 1;
    color: black;
    overflow: hidden;
    width: 0;
    height: 0;
    transition: opacity 100ms ease-out, width 1ms ease-out 100ms, height 1ms ease-out 100ms;
    width: 100%;
    height: 100%;
    flex: 1;
    background-color: white;
    text-align: center;
    display: grid;
    grid-auto-flow: row;
  }
  .calendarField section.calendarDay {
    grid-template-columns: repeat(7, 26.43px);
    grid-template-rows: repeat(7, 26.43px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 5px;
  }
  .calendarField section.calendarDay p {
    font-size: 11px;
    font-family: NunitoSansRegular, sans-serif;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    margin: 0;
    line-height: 1;
    margin-top: -1px;
  }
  .calendarField section.calendarMonth {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 52px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px 10px;
  }
  .calendarField section.calendarYear {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(7, 36px);
    justify-content: center;
    align-items: stretch;
    grid-gap: 6px 10px;
    overflow-y: scroll;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    scrollbar-width: none;
  }
  .calendarField section::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .calendarField section > button {
    font-size: ${FONT_SIZE.MMN};
    font-family: NunitoSansRegular;
    outline: 0;
    border: 1px solid transparent;
    background: transparent;
    padding: 0;
    line-height: 1em;
    position: relative;
    transition: color 30ms ease-out, background-color 30ms ease-out, border 30ms ease-out;
    cursor: pointer;
  }
  .calendarField section > button > h3 {
    padding: 0;
    margin: 0;
  }
  .calendarField section.calendarYear > button {
    border-radius: 3px;
    margin: 0;
  }
  .calendarField section.calendarMonth > button {
    border-radius: 3px;
    margin: 6px 0;
  }
  .calendarField section.calendarDay > button {
    margin: 0;
  }
  .currentCar, .prevCar, .nextCar {
    border-radius: 4px;
    width: 26.43px;
    height: 26.43px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .calendarField section > button.current-day:not([disabled]) {
    background-color: ${COLOR.BLACK_6} !important;
    border: 1px solid transparent;
    color: ${COLOR.WHITE} !important;
    box-shadow: 0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A;
  }
  .calendarField section > button.current-day:not([disabled]) p {
    color: ${COLOR.WHITE} !important;
    font-weight: 700 !important;
    font-family: NunitoSansBold, sans-serif !important;
  }
  .calendarField section > button.current-day:not([disabled]):hover {
    background: ${COLOR.BLACK_6} !important;
  }
  .calendarField section > button.currentCar:not([disabled]):hover {
    border: 1px solid ${COLOR.GRAY_21};
    color: black !important;
    background: ${COLOR.GRAY_21};
  }
  .calendarField section:active > button.currentCar:not([disabled]):hover {
    border: 1px solid ${COLOR.GRAY_21};
    background: ${COLOR.GRAY_21};
    color: black;
  }
  .calendarField section:active > button.currentCar:not([disabled]):active,
  .calendarField section > button.currentCar:not([disabled]):active {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: white;
  }
  .prevCar:hover {
    border: 1px solid ${COLOR.GRAY_21} !important;
    background: ${COLOR.GRAY_21} !important;
  }
  .nextCar:hover {
    border: 1px solid ${COLOR.GRAY_21} !important;
    background: ${COLOR.GRAY_21} !important;
  }
  .calendarField section:active > button.selectDate:not([disabled]):hover,
  .calendarField section > button.selectDate:not([disabled]):hover,
  .calendarField section > button.selectDate:not([disabled]) {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.BLACK_1} !important;
    border: 1px solid transparent;
    color: #FFFFFF !important;
    box-shadow: 0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A;
  }
  .calendarField section > button.selectDate:not([disabled]) p {
    color: #FFFFFF !important;
    font-weight: 700 !important;
    font-family: NunitoSansBold, sans-serif !important;
  }
  .calendarField section > button.selectDate:not([disabled]):hover {
    border: 1px solid transparent;
  }
  .calendarField section > button:disabled {
    color: ${COLOR.BLACK_6};
    cursor: not-allowed;
  }
  .calendarField section > button.currentCar p {
    color: ${COLOR.BLACK_6} !important;
  }
  .calendarField section > button.currentCar:active p {
    color: white !important;
  }
  .calendarField section > button.prevCar,
  .calendarField section > button.nextCar {
    color: ${COLOR.GRAY_6};
  }
  .calendarField section.calendarDay p.calendarHeader {
    color: ${COLOR.GRAY_27} !important;
    font-size: 10px !important;
    font-family: 'Nunito Sans', sans-serif !important;
    font-weight: 500 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .calendarField section > button.prevCar,
  .calendarField section > button.nextCar {
    background-color: transparent;
    border: 0px solid transparent;
    color: ${COLOR.GRAY_19};
  }
  .slide-in {
    animation-timing-function: ease-out;
    animation-duration: 100ms;
    animation-name: slide-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes slide-in {
    0% {
      max-height: 0%;
      opacity: 0.5;
    }
    100% {
      max-height: 100%;
      opacity: 1;
    }
  }
  .fade-out {
    animation-timing-function: ease-in;
    animation-duration: 100ms;
    animation-name: fade-out;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .fade-in {
    animation-timing-function: ease-out;
    animation-duration: 100ms;
    animation-name: fade-in;
    animation-iteration-count: 1;
    animation-direction: normal;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  // .jump-in {
  //   animation-timing-function: ease-out;
  //   animation-duration: 800ms;
  //   animation-name: jump-in;
  //   animation-iteration-count: 1;
  //   animation-direction: normal;
  // }
  @keyframes jump-in {
    0% {
      max-height: 0vh;
      max-width: 0vw;
      top: 50%;
      left: 50%;
      opacity: 0;
    }
    100% {
      max-height: 100vh;
      max-width: 100vw;
      top: 0;
      left: 0;
      opacity: 1;
    }
  }
  .selectDate .left {
    padding-right: 8px;
  }
  .arrow {
    text-align: end;
    display: flex;
    background-color: transparent;
    position: relative;
  }
  .arrow h1 {
    font-size: 24px;
    font-weight: normal;
    margin-bottom: 0;
    width: 32px;
    text-align: center;
    
    &:active {
      color: ${({ colorTheme }) => colorTheme || COLOR.BLACK_1};
    }
  }
  .arrow button  {
    flex: 0;
  }
  .selectDate {
    padding-left: 0px;
  }
  .selectDateThin {
    padding-left: 0px;
    padding-bottom: 16px;
  }
  .selectDateThin h1{
    font-weight: 100;
  }
`

export default Style

